export default __webpack_public_path__ + "static/media/heads-07.f23b93d5.svg";